export default __webpack_public_path__ + "static/media/sub-category-musicAndArts-dramaStudio.633f0be8.jpg";